import { createAction, handleActions } from "redux-actions";
import { takeLatest } from "redux-saga/effects";
import createRequestSaga, {
  createRequestActionType,
} from "../lib/createRequestSaga";
import * as resultAPI from "../lib/api/result";

const INITIALIZE_FORM = "result/INITIALIZE_FORM";

//학습기 결과 다시보기
const [DEVICE_SUMMARY, DEVICE_SUMMARY_SUCCESS, DEVICE_SUMMARY_FAILURE] =
  createRequestActionType("result/DEVICE_SUMMARY");
//관리자 페이지 결과 다시보기
const [PUBLIC_SUMMARY, PUBLIC_SUMMARY_SUCCESS, PUBLIC_SUMMARY_FAILURE] =
  createRequestActionType("result/PUBLIC_SUMMARY");
const [SUMMARY, SUMMARY_SUCCESS, SUMMARY_FAILURE] =
  createRequestActionType("result/SUMMARY");
const [ACHIEVEMENT, ACHIEVEMENT_SUCCESS, ACHIEVEMENT_FAILURE] =
  createRequestActionType("result/ACHIEVEMENT");
const [PUBLIC_PAPER, PUBLIC_PAPER_SUCCESS, PUBLIC_PAPER_FAILURE] = 
  createRequestActionType("reulst/PUBLIC_PAPER");

export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const deviceSummary = createAction(DEVICE_SUMMARY, ({ diag_t_id }) => ({
  diag_t_id,
}));
export const publicSummary = createAction(PUBLIC_SUMMARY, ({ token }) => ({
  token,
}));

export const publicPaper = createAction(PUBLIC_PAPER, ({ token }) => ({
  token,
}));

export const summary = createAction(
  SUMMARY,
  ({ solved_problems, achieve }) => ({
    solved_problems,
    achieve,
  })
);
export const achievement = createAction(
  ACHIEVEMENT,
  ({ solved_problems, achieve }) => ({
    solved_problems,
    achieve,
  })
);

const deviceSummarySaga = createRequestSaga(
  DEVICE_SUMMARY,
  resultAPI.deviceSummary
);

const publicSummarySaga = createRequestSaga(
  PUBLIC_SUMMARY,
  resultAPI.publicSummary
);

const publicPaperSaga = createRequestSaga(
  PUBLIC_PAPER,
  resultAPI.publicPaper
)
const summarySaga = createRequestSaga(SUMMARY, resultAPI.summary);
const achievementSaga = createRequestSaga(ACHIEVEMENT, resultAPI.achievement);
export function* resultSaga() {
  yield takeLatest(DEVICE_SUMMARY, deviceSummarySaga);
  yield takeLatest(PUBLIC_SUMMARY, publicSummarySaga);
  yield takeLatest(PUBLIC_PAPER, publicPaperSaga);
  yield takeLatest(SUMMARY, summarySaga);
  yield takeLatest(ACHIEVEMENT, achievementSaga);
}

/*
 publicSummary는 결과 다시보기시 사용하는 결과테이블이며 publicSummarySaga / deviceSummarySaga의 응답값.
 summary는 summarySaga의 응답값이며 진단검사 플로우를 따라갔을 때 결과 페이지에서 사용하는 결과테이블.
 achievement는 5대 영역의 이해도 값이며 achievementSaga의 응답값
*/
const initialState = {
  publicSummary: {},
  summary: {},
  achievement: {
    "수와 연산": 0,
    도형: 0,
    측정: 0,
    규칙성: 0,
    "자료와 가능성": 0,
  },
  publicPaper: {
    name: "",
    start_dt: "",
    grade: "",
    result: []
  },
  publicSummaryError: null,
  summaryError: null,
  achievementError: null,
  publicPaperError: null,
};

const result = handleActions(
  {
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      [form]: initialState[form],
    }),
    [DEVICE_SUMMARY_SUCCESS]: (state, { payload: form }) => ({
      ...state,
      publicSummary: form,
    }),
    [DEVICE_SUMMARY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      publicSummary: error,
      publicSummaryError: true,
    }),
    [PUBLIC_SUMMARY_SUCCESS]: (state, { payload: form }) => ({
      ...state,
      publicSummary: form,
    }),
    [PUBLIC_SUMMARY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      publicSummary: error,
      publicSummaryError: true,
    }),
    [SUMMARY_SUCCESS]: (state, { payload: form }) => ({
      ...state,
      summary: form,
    }),
    [SUMMARY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      summary: error,
      summaryError: true,
    }),
    [ACHIEVEMENT_SUCCESS]: (state, { payload: form }) => ({
      ...state,
      achievement: form,
    }),
    [ACHIEVEMENT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      achievement: error,
      achievementError: true,
    }),
    [PUBLIC_PAPER_SUCCESS]: (state, { payload: form }) => ({
      ...state,
      publicPaper: form,
    }),
    [PUBLIC_PAPER_FAILURE]: (state, {payload: error }) => ({
      ...state,
      publicPaper: error,
      publicPaperError: true,
    }),
  },
  initialState
);

export default result;
